const fontFace = (name, src, fontWeight = 'normal', fontStyle = 'normal') => ({
  fontFamily: name,
  src: `url(${`https://media-cdn.getbento.com/fonts/circular/${src}.eot`}?#iefix) format('embedded-opentype'),
            url(${`https://media-cdn.getbento.com/fonts/circular/${src}.otf`}) format('opentype'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.woff`}) format('woff'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.woff2`}) format('woff2'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.ttf`}) format('truetype'),
             url(${`https://media-cdn.getbento.com/fonts/circular/${src}.svg`}#${name}) format('svg')`,
  fontStyle,
  fontWeight,
  fontDisplay: 'swap'
});

export const FONT_NAMES = {
  reg: 'Circular',
  italic: 'CircularItalic',
  bold: 'CircularBold',
  med: 'CircularMed'
};

export const FONTFACE_CIRCULAR = {
  reg: fontFace(FONT_NAMES.reg, 'CircularStd-Book', 400),
  italic: fontFace(FONT_NAMES.italic, 'CircularStd-BookItalic', 300, 'italic'),
  bold: fontFace(FONT_NAMES.bold, 'CircularStd-Bold', 700),
  med: fontFace(FONT_NAMES.med, 'CircularStd-Medium', 500)
};
